import { Fragment } from "react";

const keyFor = (prefix, text) => `${prefix}-${text.length}-${text.slice(0, 24)}`;

function inline(text, keyPrefix) {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).filter(Boolean);
  return parts.map((p, i) => {
    const k = `${keyPrefix}-${i}-${p.slice(0, 12)}`;
    if (p.startsWith("**")) return <strong key={k} className="font-semibold text-slate-900">{p.slice(2, -2)}</strong>;
    if (p.startsWith("*")) return <em key={k}>{p.slice(1, -1)}</em>;
    return <Fragment key={k}>{p}</Fragment>;
  });
}

const ListBlock = ({ lines, ordered, blockKey }) => {
  const Tag = ordered ? "ol" : "ul";
  const strip = ordered ? /^\d+\.\s/ : /^[-•]\s/;
  return (
    <Tag className={`${ordered ? "list-decimal marker:font-semibold" : "list-disc"} pl-6 space-y-1.5 marker:text-indigo-500`}>
      {lines.map((l) => { const t = l.trim().replace(strip, ""); return <li key={keyFor(blockKey, t)}>{inline(t, keyFor(blockKey, t))}</li>; })}
    </Tag>
  );
};

export const RichText = ({ text, className = "" }) => {
  if (!text) return null;
  const blocks = text.replace(/\r\n/g, "\n").split(/\n\s*\n/);
  return (
    <div className={`space-y-4 text-base sm:text-lg text-slate-600 leading-relaxed ${className}`}>
      {blocks.map((block, bi) => {
        const lines = block.split("\n").filter((l) => l.trim());
        const blockKey = keyFor(`b${bi}`, block);
        if (lines.length && lines.every((l) => /^\d+\.\s/.test(l.trim()))) return <ListBlock key={blockKey} lines={lines} ordered blockKey={blockKey} />;
        if (lines.length && lines.every((l) => /^[-•]\s/.test(l.trim()))) return <ListBlock key={blockKey} lines={lines} ordered={false} blockKey={blockKey} />;
        return (
          <p key={blockKey}>
            {lines.map((l, li) => (
              <Fragment key={keyFor(`${blockKey}-l`, l)}>{li > 0 && <br />}{inline(l, keyFor(blockKey, l))}</Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
};
